import { Button } from '@/components/ui/button'

import { Modal, ModalProps } from './Modal'

type SchoolUserRegistrationRequestStatus =
  | 'CONFIRMED_FAILURE'
  | 'CONFIRMED_SUCCESS'
  | 'EXPIRED'
  | 'FAILED'
  | 'INPROGRESS'
  | 'SUCCEEDED'

interface Props extends ModalProps {
  status: SchoolUserRegistrationRequestStatus
  excelUrl?: string
  downloadFilename?: string
}

export const SchoolUserAsyncBatchCreateResultModal = ({
  status,
  isOpen,
  excelUrl,
  downloadFilename,
  onRequestClose,
  ...rest
}: Props): JSX.Element => {
  const modalTitle = {
    SUCCEEDED: 'ユーザーの登録が完了しました',
    FAILED: 'ユーザーの登録が失敗しました',
  } as Record<SchoolUserRegistrationRequestStatus, string>

  return (
    <Modal
      isOpen={isOpen}
      customStyles={{
        content: {
          padding: '40px 60px',
          width: '700px',
          maxWidth: '700px',
          backgroundColor: '#F5F7FC',
        },
      }}
      showCloseButton={false}
      shouldCloseOnOverlayClick={false}
      onRequestClose={onRequestClose}
      {...rest}
    >
      <h3 className="mb-6 text-center text-2xl font-bold">{modalTitle[status]}</h3>

      {status === 'SUCCEEDED' && (
        <p className="mb-5 text-center text-[15px] font-medium">
          Excel内の各ユーザーのIDとパスワードで、LOGIQ　LABOへログインすることができます。※
          更新対象のユーザーは含まれませんのでご注意ください。
          <br />
          ログイン用のパスワードはウェブからは確認できなくなりますので、ダウンロードして安全に管理してください。
        </p>
      )}

      {status === 'FAILED' && (
        <p className="mb-5 text-center text-[15px] font-medium">
          ユーザー登録中にエラーが発生しました。
          <br />
          システム管理者にお問い合わせください。
        </p>
      )}

      <div className="mt-5 flex justify-center gap-4">
        <Button
          variant="secondary"
          className="w-full max-w-[310px]"
          onClick={async (e) => {
            if (status === 'SUCCEEDED') {
              const res = await fetch(excelUrl ?? '')
              const blob = await res.blob()
              const url = window.URL.createObjectURL(blob)

              const tempLink = document.createElement('a')
              tempLink.setAttribute('href', url ?? '')
              tempLink.setAttribute('download', downloadFilename ?? '')
              tempLink.click()
              tempLink.remove()
            }

            onRequestClose?.(e)
          }}
        >
          {status === 'SUCCEEDED' && 'Excelでダウンロードして 閉じる'}
          {status === 'FAILED' && '閉じる'}
        </Button>
      </div>
    </Modal>
  )
}
